export  class Category {
    id: number;
    label: string;


    constructor(categoryResponse:any){
        this.label = categoryResponse.category;
        this.id = categoryResponse.id;
    }
}